<template>
  <div class="alert alert-dismissible" :class="'alert-' + type" role="alert" id="accordion">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="onClose">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4>
      <slot name="title">Something goes here</slot>
    </h4>
    <p>
      <slot name="body">Something else goes here</slot>&nbsp;&nbsp;
      <a v-if="collapsable" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" @click="onOpen"
        >Find Out More</a
      >
    </p>
    <div v-if="collapsable" id="collapseOne" class="panel-collapse collapse">
      <slot name="sub-body">Something else goes here</slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Metrics from "@/mixins/Metrics";

export default {
  computed: {
    ...mapGetters(['current_user']),
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    onClose() {
      this.writeMetric('interaction', {
        event: 'system-message-close',
        ref: this.current_user.id,
      });
    },
    onOpen() {
      let event = 'system-message-';
      if(this.expanded) {
        event += 'collapse';
      } else {
        event += 'expand';
      }
      this.expanded = !this.expanded;

      this.writeMetric('interaction', {
        event,
        ref: this.current_user.id,
      });
    },
  },
  mixins: [ Metrics ],
  name: 'SystemNoticeMessage',
  props: ['collapsable', 'type'],
};
</script>

<style scoped>
.alert {
  margin-top: 10px;
  margin-bottom: 0px;
}

.alert-info {
  background-color: #f0ece2;
  border-color: #c0aca2;
}
</style>
